import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  option: (styles, { isSelected, isDisabled }) => {
    return {
      ...styles,
      color: isDisabled ? "#9ca3af" : isSelected ? "#536493" : "#536493",
      backgroundColor: isDisabled
        ? "#f3f4f6"
        : isSelected
        ? "#e5e7eb"
        : "transparent",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#536493",
  }),
};
